export default __webpack_public_path__ + "static/Believe-648046328ce033099ed37cf40cbb8931.gif";